export const timeline = {
today: "اليوم",
yesterday: "الأمس",
emptyTitle: "لا يوجد نشاط بعد",
emptySub: "ستظهر هنا أحداث هذا الإجراء فور وقوعها.",
filters: {
  contact: "جهة اتصال",
all: "الكل",
asset: "الأصل",
inspection: "الفحص",
job: "المهمة",
request: "الطلب",
report: "التقرير",
},
summary: {
label: "ملخص بالذكاء الاصطناعي",
sinceToggle: "منذ آخر زيارة",
btnSummarise: "تلخيص",
btnRegenerate: "إعادة التلخيص",
btnLoading: "جاري التلخيص…",
loading: "قراءة المخطط الزمني…",
emptyHint: "اضغط تلخيص للحصول على نظرة عامة من 2-4 جمل عن هذا الأصل.",
emptyHintSite: "اضغط تلخيص للحصول على نظرة عامة من 2-4 جمل عن هذا الموقع.",
emptyHintContact: "اضغط تلخيص للحصول على نظرة عامة من 2-4 جمل عن جهة الاتصال هذه.",
errorFallback: "تعذر تحميل الملخص. يرجى المحاولة مرة أخرى.",
},
events: {
assetCreated: "تم إنشاء الأصل",
inspectionStarted: "بدأ الفحص",
inspectionCompleted: "اكتمل الفحص",
issueRaised: "تم الإبلاغ عن مشكلة",
requestRaised: "تم إنشاء الطلب",
approvalReceived: "تم استلام الموافقة",
quoteReceived: "تم استلام عرض السعر",
jobCreated: "تم إنشاء المهمة",
jobAssigned: "تم إسناد المهمة",
workCompleted: "اكتمل العمل",
evidenceAdded: "تمت إضافة دليل",
reportGenerated: "تم إنشاء التقرير",
},
};
